import { InfoIcon } from '@phosphor-icons/react';
import './checkout_fields.css';

/** Banner ⓘ do documento (node 614:8161): faixa neutra DEPOIS da alocação,
 *  dentro do cartão do viajante — lembrete de conferência, não warning. */
export function DocMatchNote({ text }: Readonly<{ text: string }>) {
  return (
    <p className="ctc-doc-match-warning">
      <InfoIcon size={16} aria-hidden />
      <span>{text}</span>
    </p>
  );
}
